import React from 'react';
import {connect} from "react-redux";
import * as actionCreators from "../../actions/actionCreators"
import Map from "../../component/map/map.js";
import moment from 'moment';

import 'moment/locale/fr';
moment.locale('fr');

class Mapcon extends React.Component{
  constructor(props) {
    super(props);

    this.onChangeDateRange = this.onChangeDateRange.bind(this)
    this.onCancelDialog = this.onCancelDialog.bind(this)
    this.openFilters = this.openFilters.bind(this)
    this.openFilters = this.openFilters.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleChangeOptions = this.handleChangeOptions.bind(this)

    this.state = {
      search: "",
      selected: null,
      lat: 46.22475,
      lng: 2.0517,
      zoom: 6,
      dialogIsOpen: false,
      dateStart: null,
      dateEnd: null,
      options: {
        clustered: true,
        status: {
          waiting: true,
          appointment: true,
          appointment_notified: true,
          issue: true,
        }
      }
    }
  }

  componentWillMount() {
    /* import les audits */
    this.props.getAuditsAction()
  }

  handleChangeOptions = type => event => {
    let options = Object.assign({}, this.state.options);
    let status = Object.assign({}, options.status);
    switch (type) {
        case 'clustered':
          options[type] = event.target.checked;
          this.setState({options: options});
          break;
        case 'waiting':
            status[type] = event.target.checked;
            options.status = status;
            this.setState({options: options});
            break;
        case 'appointment':
            status[type] = event.target.checked;
            options.status = status;
            this.setState({options: options});
            break;
        case 'appointment_notified':
            status[type] = event.target.checked;
            options.status = status;
            this.setState({options: options});
            break;
        case 'issue':
            status[type] = event.target.checked;
            options.status = status;
            this.setState({options: options});
            break;
        default:
          //
          break;
    }
  }

  openFilters() {
    this.setState({dialogIsOpen: true})
  }

  onChangeDateRange(dateStart, dateEnd) {
      this.setState({dateStart, dateEnd})
  }

  onCancelDialog() {
    this.setState({dialogIsOpen: false})
  }

  handleSearch = e => {
    var audits = (!this.state.dateStart || !this.state.dateEnd) ? this.props.audits : this.props.audits.filter(audit => (moment(audit.date).isSameOrAfter(this.state.dateStart) && moment(audit.date).isSameOrBefore(this.state.dateEnd)))
    var audit = audits.find(a => {
        return (a.company.reference.toString() === e.target.value || a.company.name.toLowerCase().includes(e.target.value.toLowerCase()))
    } )
    this.setState({
        search: e.target.value,
        selected: (audit && this.state.selected !== audit) ? audit : null,
        lat: audit ? audit.latitude : this.state.lat,
        lng: audit ? audit.longitude : this.state.lng,
        zoom: audit ? 14 : this.state.zoom,
    });
  };

  render(){
    var audits_filtered = ((!this.state.dateStart || !this.state.dateEnd) ? this.props.audits : this.props.audits.filter(audit => (!audit.date || (moment(audit.date).isSameOrAfter(this.state.dateStart) && moment(audit.date).isSameOrBefore(this.state.dateEnd)))));

    audits_filtered = audits_filtered.filter(a => this.state.options.status[a.status])

    return <Map
      options={this.state.options}
      handleChangeOptions={this.handleChangeOptions}
      dateStart={this.state.dateStart}
      dateEnd={this.state.dateEnd}
      lat={this.state.lat}
      lng={this.state.lng}
      zoom={this.state.zoom}
      dialogIsOpen={this.state.dialogIsOpen}
      audits={audits_filtered}
      openFilters={this.openFilters}
      onChangeDateRange={this.onChangeDateRange}
      onCancelDialog={this.onCancelDialog}
      handleSearch={this.handleSearch}
      search={this.state.search}
      selected={this.state.selected}
    ></Map>
  }
}

const mapStateToProps=(state)=>{
    return state
};

export default connect (mapStateToProps, actionCreators)(Mapcon);



// WEBPACK FOOTER //
// ./src/container/map/map-container.js